<script lang="ts">
	import { onMount, onDestroy } from "svelte";
	import { fly } from "svelte/transition";
	import { goto, yyyy } from "./store.svelte";

	let ready: boolean = $state(false);
	let engaged: boolean = $state(false);
	let showConfirmation: boolean = $state(false);
	let confirmTimer: ReturnType<typeof setTimeout>;

	function handleBlur() {
		if (!engaged) {
			engaged = true;
			confirmTimer = setTimeout(() => {
				showConfirmation = true;
			}, 15000);
		}
	}

	onMount(() => {
		setTimeout(() => {
			ready = true;
			yyyy.logo.usage = "logo";
		}, yyyy.logo.time);
	});

	onDestroy(() => {
		yyyy.logo.time = 877.5;
		yyyy.logo.usage = "wait";
		clearTimeout(confirmTimer);
	});
</script>

<svelte:window onblur={handleBlur} />

{#if ready}
	<div class="column is-two-thirds not-too-wide">
		<div class="card lvwr-card" class:zeroBG={!ready}>
			<div
				transition:fly|local={{ y: -200 }}
				class="card-content lvwr-card-content"
			>
				<h1 class="title thin lvwr-title">Schedule a Demo</h1>
				<div class="content lvwr-content">
					<p>
						Pick a time that works for you and we'll walk you through how
						Livewire fits your utility's needs.
					</p>
					<iframe
						src="https://calendar.google.com/calendar/appointments/schedules/AcZssZ3Bsoxi5f9deyz1Ejk1wxJFYdbZBa4L0yNB8sYKEWiKlu9Dmag8961R7I8E0vzlOhL0mXtiiAfI?gv=true"
						title="Schedule a Livewire demo"
						class="schedule-iframe"
					></iframe>
					{#if showConfirmation}
						<div class="confirmation" transition:fly={{ y: 20 }}>
							<p>You'll receive a confirmation email once you've booked.</p>
							<a
								href="/"
								onclick={(e) => { e.preventDefault(); goto("/"); }}
								class="back-link"
							>← Back to Livewire</a>
						</div>
					{/if}
				</div>
			</div>
			<footer transition:fly|local={{ y: 200 }} class="card-footer">
				<div class="card-footer-item sign-in-up-footer" style="min-height: 52px;">
					{#if !engaged}
						<button
							onclick={() => {
								goto("/");
							}}
							class="button lvwr-toggle">Back</button
						>
					{/if}
				</div>
			</footer>
		</div>
	</div>
{/if}

<style>
	.not-too-wide {
		max-width: 1100px;
	}

	.schedule-iframe {
		width: 100%;
		min-height: 40vh;
		max-height: 80vh;
		border: none;
		border-radius: 8px;
	}

	.confirmation {
		text-align: center;
		margin-top: 1.5rem;
	}

	.confirmation p {
		color: #888;
		font-size: 0.9rem;
		margin-bottom: 0.75rem;
	}

	.back-link {
		color: #ff3e00;
		text-decoration: none;
		font-weight: 600;
	}

	.back-link:hover {
		text-decoration: underline;
	}
</style>
